import { computed } from "vue";

import useLegacyStore from "@Composables/useLegacyStore";

export default function useBillingPeriod() {
  const { getters } = useLegacyStore();

  const billingPeriod = computed(() => getters.userLimits?.billing_period ?? {});
  const billingPeriodMonthStartsAt = computed(() => billingPeriod.value.month_starts_at ?? null);
  const billingPeriodMonthEndsAt = computed(() => billingPeriod.value.month_ends_at ?? null);
  const billingPeriodStartsAt = computed(() => billingPeriod.value.starts_at ?? null);
  const billingPeriodEndsAt = computed(() => billingPeriod.value.ends_at ?? null);

  return {
    billingPeriodMonthStartsAt,
    billingPeriodMonthEndsAt,
    billingPeriodStartsAt,
    billingPeriodEndsAt,
  };
}
